import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { supabase } from "@/integrations/supabase/client";
import Onboard from "./Onboard";

export default function Index() {
  const { session, loading } = useAuth();
  const nav = useNavigate();
  const [onboarded, setOnboarded] = useState<boolean | null>(null);

  useEffect(() => {
    if (loading || !session) return;
    const uid = session.user.id;
    Promise.all([
      supabase.from("profiles").select("onboarding_complete").eq("id", uid).maybeSingle(),
      supabase.from("user_roles").select("role").eq("user_id", uid).eq("role", "admin").maybeSingle(),
    ]).then(([{ data: profile }, { data: adminRole }]) => {
      if (adminRole) { setOnboarded(true); return; }
      setOnboarded(profile?.onboarding_complete ?? false);
    });
  }, [session, loading]);

  useEffect(() => {
    if (onboarded === true) nav("/home", { replace: true });
  }, [onboarded, nav]);

  // Auth loading or profile fetch in flight — render nothing to avoid flash
  if (loading || (session && onboarded === null)) return null;

  // Signed in but onboarding incomplete — keep them in the flow
  if (session && onboarded === false) return <Onboard />;

  // Signed out — drop them on the Onboard splash (big fig logo +
  // "Get started" + "I have an account"). The waitlist landing has
  // been retired now that signup is open.
  return <Onboard />;
}
